module.exports = __webpack_public_path__ + "media/images/how_it_works/4-fb6a5ed22c189542e21dfca1faf07637.svg";